"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyDatatype = void 0;
// DOCUMENTATION: Original property types used
// export enum DutchPropertyDatatype {
//   Cijfer = "Cijfer",
//   Datum = "Datum",
//   Decimaal = "Decimaal",
//   Ja = "Ja",
//   JaNee = "Ja/Nee",
//   Keuze = "Keuze",
//   Meerkeuze = "Meerkeuze",
//   Text = "Text",
//   Text1Regel = "Text (1 regel)",
// }
var PropertyDatatype;
(function (PropertyDatatype) {
    PropertyDatatype["integer"] = "integer";
    PropertyDatatype["date"] = "date";
    PropertyDatatype["decimal"] = "decimal";
    PropertyDatatype["yes"] = "yes";
    PropertyDatatype["yesno"] = "yesno";
    PropertyDatatype["choice"] = "choice";
    PropertyDatatype["multichoice"] = "multichoice";
    PropertyDatatype["freetext"] = "freetext";
})(PropertyDatatype = exports.PropertyDatatype || (exports.PropertyDatatype = {}));
//# sourceMappingURL=PropertiesSource.js.map